import React from "react"

import PropTypes from "prop-types"

import Typography, {TYPOGRAPHY_VARIANTS} from "../Typography"

import "./style.scss"

export const LOGIN_SECTION_VARIANTS = {DEFAULT: "default", LARGE: "large"}

const LoginSection = ({children, className, title = null, variant = LOGIN_SECTION_VARIANTS.DEFAULT}) => (
    <div className={`login-section variant-${variant} ${className ? className : ""}`}>
        {title && (
            <Typography as="h1" className="login-section-title" variant={TYPOGRAPHY_VARIANTS.H2}>
                {title}
            </Typography>
        )}
        {children}
    </div>
)

LoginSection.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    title: PropTypes.string,
    variant: PropTypes.oneOf(Object.values(LOGIN_SECTION_VARIANTS)),
}

export default LoginSection
